import script from "./StudentsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentsPage.vue?vue&type=script&setup=true&lang=js"

import "./StudentsPage.vue?vue&type=style&index=0&id=f8caa7b4&lang=css"

const __exports__ = script;

export default __exports__